import colors from "../../base/colors";
import borders from "../../base/borders";
import boxShadows from "../../base/boxShadows";

import rgba from "../../functions/rgba";

const { white } = colors;
const { borderRadius } = borders;

const card = {
  styleOverrides: {
    root: {
      display: "flex" as const,
      flexDirection: "column" as const,
      position: "relative" as const,
      minWidth: 0,
      wordWrap: "break-word" as const,
      backgroundColor: white.main,
      backgroundClip: "border-box" as const,
      border: `1px solid ${rgba(colors.grey[200], 0.8)}`,
      borderRadius: borderRadius.lg,
      boxShadow: boxShadows.sm,
      overflow: "visible" as const,
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",

      "&:hover": {
        boxShadow: boxShadows.md,
        transform: "translateY(-2px)",
        borderColor: rgba(colors.grey[300], 0.8),
      },
    },
  },
};

export default card;
